import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaFutbol, FaCalendarAlt, FaUsers } from 'react-icons/fa';

function ManagerSeasonList() {
    const [seasons, setSeasons] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSeasons = async () => {
            try {
                const response = await axios.get('/api/leagues/seasons/open_registrations/', {
                    withCredentials: true,
                });
                setSeasons(response.data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching seasons:", error);
                setError("Failed to load seasons.");
                setLoading(false);
            }
        };

        fetchSeasons();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'short' });
        const year = date.getFullYear();

        // Add ordinal suffix to day
        const ordinal = (day) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        };

        return `${month} ${day}${ordinal(day)} ${year}`;
    };

    if (loading) {
        return (
            <div className="container py-4">
                <div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container py-4">
                <div className="alert alert-danger" role="alert">
                    <i className="bi bi-exclamation-triangle-fill me-2"></i>
                    {error}
                </div>
            </div>
        );
    }

    return (
        <div className="container py-4">
            <div className="row mb-4">
                <div className="col">
                    <h2 className="mb-0">
                        <FaFutbol className="me-2" />
                        Active Seasons
                    </h2>
                    <p className="text-muted">Seasons currently open for registration</p>
                </div>
            </div>

            {seasons.length === 0 ? (
                <div className="card">
                    <div className="card-body text-center py-5">
                        <FaCalendarAlt size={48} className="text-muted mb-3" />
                        <h4>No Active Seasons</h4>
                        <p className="text-muted">There are currently no seasons open for registration.</p>
                    </div>
                </div>
            ) : (
                <div className="row g-4">
                    {seasons.map((season) => (
                        <div key={season.id} className="col-md-6 col-lg-4">
                            <div className="card h-100">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-start mb-3">
                                        <h5 className="card-title mb-0">
                                            <Link
                                                to={`/league-manager/seasons/${season.id}/details`}
                                                className="text-decoration-none"
                                            >
                                                {season.name}
                                            </Link>
                                        </h5>
                                        <span className="badge bg-success">Registration Open</span>
                                    </div>

                                    <div className="mb-3">
                                        <p className="small text-muted mb-1">
                                            <FaCalendarAlt className="me-1" />
                                            Season Dates
                                        </p>
                                        <p className="mb-0">
                                            {formatDate(season.start_date)} - {formatDate(season.end_date)}
                                        </p>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center">
                                        <Link
                                            to={`/league-manager/seasons/${season.id}/details`}
                                            className="btn btn-primary btn-sm"
                                        >
                                            View Details
                                        </Link>
                                        <span className="text-muted small">
                                            <FaUsers className="me-1" />
                                            {season.team_count || 0} Teams
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default ManagerSeasonList; 